import { Cookies } from 'react-cookie';

 function getDomainId  ()  {
    const cookies = new Cookies();
    const domain_id = cookies.get('domain_id');
    return domain_id ? domain_id : null;
};
export {  getDomainId };
